import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminLayout } from "@/layouts/AdminLayout";
import { MemberLayout } from "@/layouts/MemberLayout";
import Index from "./pages/Index";
const Ideas = lazy(() => import("./pages/Ideas"));
const Events = lazy(() => import("./pages/Events"));
const Stores = lazy(() => import("./pages/Stores"));
const StoreDetail = lazy(() => import("./pages/StoreDetail"));
const Membership = lazy(() => import("./pages/Membership"));
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const AGBGutscheine = lazy(() => import("./pages/AGBGutscheine"));
const Dokumente = lazy(() => import("./pages/Dokumente"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Login = lazy(() => import("./pages/auth/Login"));
const Register = lazy(() => import("./pages/auth/Register"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const AdminMembers = lazy(() => import("./pages/admin/Members"));
const AdminSubscribers = lazy(() => import("./pages/admin/Subscribers"));
const AdminNewsletter = lazy(() => import("./pages/admin/Newsletter"));
const AdminEvents = lazy(() => import("./pages/admin/Events"));
const AdminIdeas = lazy(() => import("./pages/admin/Ideas"));
const AdminChristmasWishes = lazy(() => import("./pages/admin/ChristmasWishes"));
const MemberProfile = lazy(() => import("./pages/member/Profile"));
const ChristmasWish = lazy(() => import("./pages/ChristmasWish"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/ideen" element={<Layout><Ideas /></Layout>} />
            <Route path="/events" element={<Layout><Events /></Layout>} />
            <Route path="/gutscheine" element={<Layout><Stores /></Layout>} />
            <Route path="/gutscheine/:slug" element={<Layout><StoreDetail /></Layout>} />
            <Route path="/mitmachen" element={<Layout><Membership /></Layout>} />
            <Route path="/weihnachtswunsch" element={<ChristmasWish />} />
            <Route path="/impressum" element={<Layout><Impressum /></Layout>} />
            <Route path="/datenschutz" element={<Layout><Datenschutz /></Layout>} />
            <Route path="/agb-gutscheine" element={<Layout><AGBGutscheine /></Layout>} />
            <Route path="/dokumente" element={<Layout><Dokumente /></Layout>} />
            
            {/* Auth Routes */}
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/register" element={<Register />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="admin">
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="members" element={<AdminMembers />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="ideas" element={<AdminIdeas />} />
              <Route path="christmas-wishes" element={<AdminChristmasWishes />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
            </Route>
            
            {/* Member Routes */}
            <Route path="/member" element={
              <ProtectedRoute requiredRole="member">
                <MemberLayout />
              </ProtectedRoute>
            }>
              <Route index element={<MemberProfile />} />
            </Route>
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
